// extracted by mini-css-extract-plugin
export default {"section":"RequisitesPage_section__YW4c6","title":"RequisitesPage_title__cAsVX"};